import React, {Component} from 'react';
import {Card, Layout} from 'antd';
import SAInputLabel from '../../../components/common/input/SAInputLabel';
import SAInputDistance from '../../../components/common/input/SAInputDistance';
import SADropdown from '../../../components/common/dropdown/SADropdown';
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";

class GeneralInformationFragment extends Component {
  renderInputLabel = (name, value, label, onChange, disabled, mandatory, maxLenght) => (
    <li>
      <SAInputLabel
        name={name}
        value={value}
        label={label}
        onChange={onChange}
        disabled={disabled}
        maxLength={maxLenght}
        error={mandatory && !value ? {message: 'error.not.null'} : null}
      />
    </li>
  );

  renderSelectLabel = (name, value, onChange, disabled, list, label, formatMessage) => (
    <li>
      <div className="form-field" style={{ marginBottom: '.5rem' }}>
        <label htmlFor="birthDateLabel">{formatMessage({ id: label })}</label>
        <SADropdown
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          choices={list}
        />
      </div>
    </li>
  );

  renderInputDistance = (
    name,
    value,
    label,
    onChange,
    min,
    defaultValue,
    formatMessage,
    mandatory,
  ) => (
    <li>
      <div className="form-field" style={{ marginBottom: '.5rem' }}>
        <label htmlFor="birthDateLabel">{formatMessage({ id: label })}</label>
        <SAInputDistance
          value={value}
          onChange={onChange}
          min={min}
          step={100}
          defaultValue={defaultValue}
          error={mandatory && !value ? {message: 'error.not.null'} : null}
        />
      </div>
    </li>
  );

  onGeneralInformationChange = (value) => {
    this.props.dispatchSaveGeneralInformation({...value});
  };

  render() {
    const {
      intl:{formatMessage},
      leasingCompanies,
      selectedDealer,
      selectedVehicle,
      selectedVIN,
    } = this.props;
    const { generalInformation = {} } = this.props.createAppointmentRequest;
    let leasingList;
    if (leasingCompanies) {
      leasingList = leasingCompanies.map(e => ({ value: e.name, display: e.name }));
      leasingList.splice(0, 0, { value: null, display: '' });
    }
    return (
      <Layout>
        <Card
          title={<h2>{formatMessage({ id: 'customer.journey.step.generalInformation.title' }).toUpperCase()}</h2>}
          bordered={false}
          style={{ width: '100%' }}
        >
          <div className="wrap">
            <div className="content">
              <ul className="list">
                {this.renderInputLabel(
                  'Dealer',
                  selectedDealer.dealerName,
                  'customer.journey.step.generalInformation.dealer',
                  () => {},
                  true
                )}
                {this.renderInputLabel(
                  'Vehicle',
                  selectedVIN
                    ? selectedVIN.brand
                    : `${selectedVehicle.brand} ${selectedVehicle.model}`,
                  'vehicle.make',
                  () => {},
                  true
                )}
                {selectedVIN &&
                  this.renderInputLabel(
                    'VehicleModel',
                    generalInformation.vinVehicleModel,
                    'vehicle.model',
                    (e)=>this.onGeneralInformationChange({vinVehicleModel: e.target.value}),
                    false,
                    true
                  )}
                {leasingList &&
                  this.renderSelectLabel(
                    'LeasingCompany',
                    generalInformation.leasingCompany || '',
                    (e)=>this.onGeneralInformationChange({leasingCompany: e.target.value}),
                    false,
                    leasingList,
                    'customer.journey.step.generalInformation.leasingCompany',
                    formatMessage
                  )}
                {this.renderInputDistance(
                  'Mileage',
                  generalInformation.mileage,
                  'customer.journey.step.generalInformation.mileage',
                  (value)=>this.onGeneralInformationChange({mileage: value}),
                  0,
                  0,
                  formatMessage,
                  true
                )}
                {this.renderInputLabel(
                  'PlateNumber',
                  generalInformation.plateNumber,
                  'summary.license-plate',
                  (e)=>this.onGeneralInformationChange({plateNumber: e.target.value}),
                  false,
                  true,
                  15,
                )}
                {this.renderInputLabel(
                  'PhoneNumber',
                  generalInformation.phoneNumber,
                  'summary.phone',
                  (e)=>this.onGeneralInformationChange({phoneNumber: e.target.value}),
                  false,
                  true,
                  15,
                )}
              </ul>
            </div>
          </div>
        </Card>
      </Layout>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchSaveGeneralInformation: (params) => dispatch({ type: 'SAVE.GENERAL_INFORMATION',  params}),

});

const mapStateToProps = state => ({
  stepper: state.stepper,
  selectedVehicle: state.customerVehicle.selectedVehicle,
  createAppointmentRequest: state.createAppointmentRequest,
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(GeneralInformationFragment)
);



// WEBPACK FOOTER //
// ./src/public/journey1/fragments/GeneralInformationFragment.js